// docs/145 KH4: the base pieces (fk-grammar `ITEM_DEFS`, ids 100–192: the forge's loadouts and backgrounds, the
// shops' plain stock) are not catalogue pieces and have no kit art of their own. Each wears the art of a plain
// common catalogue piece of its own family, chosen to look like what it is (a "Sword" an arming sword, "Plate" a
// battered knight's plate), so every item a hero carries has kit art: its icon, its worn layers and its dye.
export const BASE_ITEM_ART: Readonly<Record<number, number>> = {
  100: 1004, // Sword: Cold Iron Arming Sword
  101: 1185, // Axe: Raider's Bearded Axe
  102: 1255, // Mace: Pilgrim's Flanged Mace
  103: 1123, // Dagger: Wolf-Tooth Dirk
  104: 1371, // Spear: Boar-Hunter's Spear
  105: 1504, // Bow: Gallowsfield Longbow
  106: 1572, // Crossbow: Watch-Sergeant's Crossbow
  107: 1470, // Staff: Drover's Quarterstaff
  108: 1611, // Wand: Oak-Heart Wand
  110: 1861, // Buckler: Cold-Iron Buckler of Kettlecross
  111: 1876, // Round shield: Pilgrim-Knight's Roundel
  112: 1895, // Kite shield: Kite of the Fordwater Levy
  113: 1918, // Tower shield: Barrow-Lid Tower Shield
  114: 1715, // Focus: Hedge-Witch's Cloudy Orb
  120: 1751, // Cloth: Novice's Grey Habit
  121: 1779, // Leather: Tanner's Boiled Jack
  122: 1809, // Chain: Hedge Knight's Chain Shirt
  123: 1855, // Plate: Knight-Errant's Battered Plate
  130: 1933, // Cap: Poacher's Felt Hood
  131: 1965, // Kettle helm: Watchman's Kettle Hat
  132: 1991, // Great helm: Great Helm of the Gatehouse
  140: 2002, // Traveller's cape: Pilgrim's Dust Mantle
  141: 2003, // Hooded cape: Molecatcher's Hood
  142: 2009, // Warded cape: Cat-Nap Velvet Cloak
  143: 2023, // Heavy cape: Bearfolk Shoulder-Pelt
  150: 2264, // Iron ring: Cobbler's Iron Ring
  151: 2357, // Whetstone charm: Hearthstone Chip
  152: 3009, // Candle of focus: Tallow Candle Stub
  153: 2362, // Runner's knot: Tarred Sailor's Knot
  154: 4453, // Herb pouch: Pouch of Rock Salt
  160: 2583, // Salve: Merciful Balm
  161: 2507, // Tonic: Haverbrook Soothing Tonic
  162: 2959, // Smokepot: Ash-Fen Smoke Pot
  163: 2757, // Scroll of Revealing: Hedge-Witch's Seeing Leaf
  170: 2055, // Leather gloves: Hedge-Layer's Hide Mitts
  171: 2066, // Gauntlets: Ice-Fisher's Gauntlets
  172: 3457, // Spellwoven wraps: Abbey Healer's Linen Wraps
  180: 2115, // Soft boots: Poacher's Soft-Toe Boots
  181: 2133, // Iron-shod boots: Pikeman's Iron-Shod Sabatons
  182: 2110, // Striding boots: Quick-March Brogans
  190: 2446, // Amulet of vigour: Amulet of Hearty Health
  191: 2439, // Ward pendant: Hedge-Wizard's Hollow Pendant
  192: 2467, // Wellspring torc: Torc of the Fen Warden
};

/** The catalogue piece whose art a def wears: its own, or a base piece's stand-in. */
export const artDefOf = (def: number): number => BASE_ITEM_ART[def] ?? def;
